import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpBackend from "i18next-http-backend";
import { initReactI18next } from "react-i18next";

i18n
  .use(HttpBackend) // Loads translations on demand from /locales/{lng}/{ns}.json
  .use(LanguageDetector) // Detects user language from browser
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    fallbackLng: "en",
    defaultNS: "common",
    ns: [
      "admin_panel",
      "alerts",
      "account",
      "authentication",
      "assets",
      "common",
      "dashboard",
      "expenses",
      "financials",
      "members",
      "membership",
      "onboarding",
      "payouts",
      "projects",
      "analytics",
      "reports",
      "settings",
      "sources",
      "support",
    ],

    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      queryStringParams: { v: Date.now() },
    },

    interpolation: {
      escapeValue: false, // React already escapes values
    },

    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
